import React from 'react';
import * as Icon from 'react-feather';
import { all_routes } from '../routes/all_routes';
const routes = all_routes;
export const adminSidebar = [
  {
    tittle: 'Admin Management',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Admin Management',
        hasSubRoute: true,
        showSubRoute: false,
        route: routes.listAdmins,
        icon: <Icon.Users className="react-feather-icon" />,
        subMenus: [
          {
            menuValue: 'All Admins',
            route: routes.listAdmins,
          },
          {
            menuValue: 'Create Admin',
            route: routes.createAdmin,
          },
          {
            menuValue: 'All Users',
            route: routes.allUsers,
          },
        ],
      },
    ],
  },
  {
    tittle: 'Platform Settings',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Badges',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.listBadges,
        icon: <Icon.Award className="react-feather-icon" />,
      },
      {
        menuValue: 'Tags',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.listTags,
        icon: <Icon.Tag className="react-feather-icon" />,
      },
      {
        menuValue: 'Terms & Conditions',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.listTerms,
        icon: <Icon.FileText className="react-feather-icon" />,
      },
      {
        menuValue: 'Privacy Policy',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.listPrivacyPolicies,
        icon: <Icon.Shield className="react-feather-icon" />,
      },
    ],
  },
  {
    tittle: 'Community Management',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'Community Management',
        hasSubRoute: true,
        showSubRoute: false,
        route: routes.listCommunities,
        icon: <Icon.Users className="react-feather-icon" />,
        subMenus: [
          {
            menuValue: 'All Communities',
            route: routes.listCommunities,
          },
          {
            menuValue: 'Create Community',
            route: routes.createCommunity,
          },
        ],
      },
      {
        menuValue: 'Community Tags',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.communityTags,
        icon: <Icon.Hash className="react-feather-icon" />,
      },
    ],
  },
  {
    tittle: 'Moderation',
    showAsTab: false,
    separateRoute: false,
    menu: [
      {
        menuValue: 'User Reports',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.listUserReports,
        icon: <Icon.AlertCircle className="react-feather-icon" />,
      },
      {
        menuValue: 'Curated Content',
        hasSubRoute: false,
        showSubRoute: false,
        route: routes.listCuratedContents,
        icon: <Icon.Star className="react-feather-icon" />,
      },
    ],
  },
];
